
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/30DayChangeMind",
      function () {
        return require("private-next-pages/article/30DayChangeMind.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/30DayChangeMind"])
      });
    }
  